<template>
	<div
		v-if="isSmallMobile"
		class="sticky-offer-button"
		:class="{ 'sticky-offer-button--visible': props.visible }"
	>
		<RoundedButton
			class="sticky-offer-button__button"
			theme="extra"
			@click="handleClick"
		>
			Angebote ab&nbsp;{{ totalPrice }}
		</RoundedButton>
	</div>
</template>
<script lang="ts" setup>
import RoundedButton from '@lmt-rpb/RoundedButton/RoundedButton.vue';
import { useStore } from '@/components/common/store';
import { formatPrice } from '@/js/utils/priceUtils';
import { computed } from 'vue';
import { scrollToHashWithDynamicOffset } from '@utils/utils';
import { getTotalPrice } from '@/js/utils/priceUtils';
import { getDefaultCurrency } from '@utils/environmentUtils';
import { storeToRefs } from 'pinia';
import { useBreakpointStore } from 'src/store/breakpointsStore';

type Props = {
	visible?: boolean;
};

const store = useStore();
const { isSmallMobile } = storeToRefs(useBreakpointStore());

const props = defineProps<Props>();
const bestOffer = computed(() => store.state.bestOffer);
const totalPrice = computed(() => formatPrice(getTotalPrice(bestOffer.value?.Pricing ?? {}), getDefaultCurrency()));

const handleClick = () => {
	scrollToHashWithDynamicOffset('offers', false);
};
</script>

<style lang="scss" scoped>
.sticky-offer-button {
	position: fixed;
	bottom: 2.4rem;
	left: 50%;
	transform: translateX(-50%);
	z-index: 10000;
	width: 80%;
	transition: opacity ease 0.2s;
	opacity: 0;
	pointer-events: none;

	&--visible {
		opacity: 1;
		pointer-events: all;
	}

	&__button {
		width: 100%;
		padding-inline: 2rem;
		font-size: $font-small-1;
	}

	:deep(.button--extra) {
		font-size: $font-small-1;

		&:hover,
		&:focus,
		&:focus-visible {
			opacity: 1;
			background: $color-extra;
		}
	}
}
</style>
